export const FeatureName = 'admin';
